'use strict';

angular.module('cdPay.models', ['ngResource']);
